import MRNList from '../../../components/HSEQ/MRN/MRNList'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function MRN(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>HSEQ</Breadcrumb.Item>
              <Breadcrumb.Item href="#/hseq/mrn/list">Release Notes</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Goods & Material Release Notes'}
              subtitle={
                'Goods & Material Release Notes for Purchased & Fabricated Items issued before shipment of goods.'
              }
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <MRNList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

MRN.propTypes = {}
MRN.defaultProps = {}

export default MRN
